const isLogin = (state) => state.isLogin;
const danhSachDonViVaChucVu = (state) => state.danhSachDonViVaChucVu;
const danhSachQuyen = (state) => state.danhSachQuyen;
const nhiemVuCaNhanTabIndex = (state) => state.nhiemVuCaNhanTabIndex;
const listDonViNgoai = (state) => state.listDonViNgoai;
const listDonViTrong = (state) => state.listDonViTrong;
const listCanBo = (state) => state.listCanBo;
const listLoaiVanBan = (state) => state.listLoaiVanBan;
const listDoKhan = (state) => state.listDoKhan;
const listLuongKyDuyet = (state) => state.listLuongKyDuyet;
const multiDonViTrong = (state) => state.multiDonViTrong;
const multiDonViNgoai = (state) => state.multiDonViNgoai;
const multiCanBo = (state) => state.multiCanBo;
const multiNguoiDung = (state) => state.multiNguoiDung;
const allSoDen = (state) => state.allSoDen;
const allSoDi = (state) => state.allSoDi;
const allSoDenTraCuu = (state) => state.allSoDenTraCuu;
const thongTinUser = (state) => state.thongTinUser;
const danhSachCanBo = (state) => state.danhSachCanBo;
const danhSachDonViTrongIgnore = (state) => state.danhSachDonViTrongIgnore;
const danhSachDonViNgoaiIgnore = (state) => state.danhSachDonViNgoaiIgnore;
const isLoading = (state) => state.isLoading;
const danhSachCanBoVanThu = (state) => state.danhSachCanBoVanThu;
const danhSachDonViTrongNgoai = (state) => state.danhSachDonViTrongNgoai;
const scanStatus = (state) => state.scanStatus;
const danhSachCotHienThi = (state) => state.danhSachCotHienThi;
const isReloadList = (state) => state.isReloadList
const infFilterTraCuu = (state) => state.infFilterTraCuu
const isIframe = (state) => state.isIframe

export default {
  allSoDenTraCuu,
  infFilterTraCuu,
  danhSachDonViNgoaiIgnore,
  danhSachDonViTrongIgnore,
  danhSachCanBo,
  isLogin,
  danhSachDonViVaChucVu,
  danhSachQuyen,
  nhiemVuCaNhanTabIndex,
  listDonViNgoai,
  listDonViTrong,
  listCanBo,
  listLoaiVanBan,
  listDoKhan,
  listLuongKyDuyet,
  multiDonViTrong,
  multiDonViNgoai,
  multiCanBo,
  allSoDen,
  isLoading,
  danhSachCanBoVanThu,
  danhSachDonViTrongNgoai,
  scanStatus,
  danhSachCotHienThi,
  thongTinUser,
  isReloadList,
  isIframe,
  allSoDi,
  multiNguoiDung
};
